import React from 'react'
import ReactDOM from 'react-dom/client'
import ThailandPackingList from './ThailandPackingList.jsx'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ThailandPackingList />
  </React.StrictMode>,
)